import appConfig from './apiConfig';


//fetchAlldemoCategoriesApi
  export const fetchAlldemoCategoriesApi =(token)=>{

    const headers = Object.assign({'content-type':'application/json',
                                   'accept':'*/*'
                               });
    const request= new Request( appConfig.siteURL+'alldemoCategories/'+token, {
      method : "GET",
      headers : headers,
    });
    
    return fetch(request).then(response => {
        return  response.json().then( demoCatDataResponse => {
          return demoCatDataResponse;
        });
      }).catch(error => {
       return error;
     });
    }
  
//createDemoCategoryApi

// export const createDemoCategoryApi =(data)=>{
//   let objData =  JSON.stringify(data);
//   const headers = Object.assign({'content-type':'application/json',
//                                   'accept':'*/*'
//                               });
//   const request= new Request( appConfig.siteURL+'createCategory', {
//     method : "POST",
//     headers : headers,
//     body : objData
//   });
  
//   return fetch(request).then(response => {
//       return  response.json().then(demographicsResponse => {
//         return demographicsResponse;
//       });
//     }).catch(error => {
//       return error;
//     });
//   }



export const createDemoCategoryApi =(data)=>{

  const headers = Object.assign({'content-type':"application/x-www-form-urlencoded",
                                 'accept':'*/*'});
  const request= new Request( appConfig.siteURL+'createCategory', {
  
    method : "POST",
    //headers : headers,
    body : data
  });
  
  return fetch(request).then(response => {
      return  response.json().then(categoryResponse => {
        if(categoryResponse.success){
        return categoryResponse;
      }else{
        return categoryResponse;
      }
      });
    }).catch(error => {
     return error;
   });
  }

  //deleteCategoryApi

  export const deleteCategoryApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'removeCategory', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

  //getAllDemoQuestionByCategoryApi
  export const getAllDemoQuestionByCategoryApi =(catId)=>{

  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'getAllDemoQuestionByCategory/'+catId, {
    method : "GET",
    headers : headers,
  });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //updateDemoCategoryApi
  export const updateDemoCategoryApi =(data)=>{
   
    const headers = Object.assign({'content-type':"application/x-www-form-urlencoded",
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'updateCategory', {
      method : "POST",
     // headers : headers,
      body : data
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

  //addDemographicsQuestionApi
  export const addDemographicsQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'insertQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

  //softDeleteCategoryQuestionApi
  export const softDeleteCategoryQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'removeCategoryQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

//getAlloptionsByQuestionApi
export const getAlloptionsByQuestionApi =(quesId)=>{

  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'getAlloptionsByQuestion/'+quesId, {
    method : "GET",
    headers : headers,
  });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //updateQuestionDemographicsApi

  export const updateQuestionDemographicsApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'updateQuestionDemographics', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

  //addOptionByQuestionApi
  export const addOptionByQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'insertOptions', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

  //updateOptionByQuestionApi
  export const updateOptionByQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'updateOptionDemographics', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //softDeleteOptionApi

export const softDeleteOptionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'removeOption', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

//getSubQuestionListApi
  export const getSubQuestionListApi =( catId, quesId)=>{

    const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
    const request= new Request( appConfig.siteURL+'getAllSubQuestion/'+ catId +'/'+ quesId, {
      method : "GET",
      headers : headers,
    });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //insertSubQuestionApi.......

  export const insertSubQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'insertSubQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }


    //softDeleteSubQuestionApi

    export const softDeleteSubQuestionApi =(data)=>{
      let objData =  JSON.stringify(data);
      const headers = Object.assign({'content-type':'application/json',
                                      'accept':'*/*'
                                  });
      const request= new Request( appConfig.siteURL+'removeSubQuestion', {
        method : "POST",
        headers : headers,
        body : objData
      });
      
      return fetch(request).then(response => {
          return  response.json().then(demographicsResponse => {
            return demographicsResponse;
          });
        }).catch(error => {
          return error;
        });
      }

  //getSubQuesDataByIdApi
  export const getSubQuesDataByIdApi =( id)=>{

    const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
    const request= new Request( appConfig.siteURL+'getSubQuesDataById/'+ id , {
      method : "GET",
      headers : headers,
    });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //updatesubQuestionApi

  export const updatesubQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'updatesubQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }

//getSubQuesOptionsByIdApi

export const getSubQuesOptionsByIdApi =( id)=>{

  const headers = Object.assign({'content-type':'application/json',
                                'accept':'*/*'
                            });
  const request= new Request( appConfig.siteURL+'getSubOptionsById/'+ id , {
    method : "GET",
    headers : headers,
  });

return fetch(request).then(response => {
    return  response.json().then( demoCatDataResponse => {
      return demoCatDataResponse;
    });
  }).catch(error => {
   return error;
 });
}

//softDeleteSubOptionApi
  export const softDeleteSubOptionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'removeSubOption', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

//addSubOptionBySubQuestionApi
export const addSubOptionBySubQuestionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'insertSubOptions', {
    method : "POST",
    headers : headers,
    body : objData
  });

return fetch(request).then(response => {
    return  response.json().then(demographicsResponse => {
      return demographicsResponse;
    });
  }).catch(error => {
    return error;
  });
}

//getSubOptionDataByOptionIdApi
export const getSubOptionDataByOptionIdApi =( id)=>{

  const headers = Object.assign({'content-type':'application/json',
                                'accept':'*/*'
                            });
  const request= new Request( appConfig.siteURL+'getSubOptionsByOptionId/'+ id , {
    method : "GET",
    headers : headers,
  });

return fetch(request).then(response => {
    return  response.json().then( demoCatDataResponse => {
      return demoCatDataResponse;
    });
  }).catch(error => {
   return error;
 });
}

//UpdateSubOptionApi
export const UpdateSubOptionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'UpdateSubOption', {
    method : "POST",
    headers : headers,
    body : objData
  });

return fetch(request).then(response => {
    return  response.json().then(demographicsResponse => {
      return demographicsResponse;
    });
  }).catch(error => {
    return error;
  });
}

//getSecSubQuestionListApi

export const getSecSubQuestionListApi =( catId, quesId, subQuesId)=>{

  const headers = Object.assign({'content-type':'application/json',
                                'accept':'*/*'
                            });
  const request= new Request( appConfig.siteURL+'getAllSecSubQuestion/'+ catId +'/'+ quesId +'/'+subQuesId, {
    method : "GET",
    headers : headers,
  });

return fetch(request).then(response => {
    return  response.json().then( demoCatDataResponse => {
      return demoCatDataResponse;
    });
  }).catch(error => {
   return error;
 });
}

//insertSecSubQuestionApi
export const insertSecSubQuestionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'insertSecondSubQuestion', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //getSecSubQuesDataByIdApi
  export const getSecSubQuesDataByIdApi =( id)=>{

    const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
    const request= new Request( appConfig.siteURL+'getSecSubQuesDataById/'+ id , {
      method : "GET",
      headers : headers,
    });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //updateSecSubQuestionApi
  export const updateSecSubQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'updateSecSubQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(demographicsResponse => {
          return demographicsResponse;
        });
      }).catch(error => {
        return error;
      });
    }
  
  //getSecSubQuesOptionsByIdApi
  export const getSecSubQuesOptionsByIdApi =( id)=>{

    const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
    const request= new Request( appConfig.siteURL+'getSecSubQuesOptionsById/'+ id , {
      method : "GET",
      headers : headers,
    });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //addSecSubOptionBySubQuestionApi
  export const addSecSubOptionBySubQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'insertSecondSubOptions', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //softDeleteSecSubOptionApi
  export const softDeleteSecSubOptionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'removeSecSubOption', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //softDeleteSecSubQuestionApi
  export const softDeleteSecSubQuestionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'removeSecSubQuestion', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //getSecSubOptionDataByOptionIdApi
  export const getSecSubOptionDataByOptionIdApi =( id)=>{
  

    const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
    const request= new Request( appConfig.siteURL+'getSecSubOptionDataByOptionId/'+ id , {
      method : "GET",
      headers : headers,
    });
  
  return fetch(request).then(response => {
      return  response.json().then( demoCatDataResponse => {
        return demoCatDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //UpdateSecSubOptionApi
  export const UpdateSecSubOptionApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'UpdateSecSubOption', {
      method : "POST",
      headers : headers,
      body : objData
    });
  
  return fetch(request).then(response => {
      return  response.json().then(demographicsResponse => {
        return demographicsResponse;
      });
    }).catch(error => {
      return error;
    });
  }


// WEBPACK FOOTER //
// ./src/api/demographicsApi.js